export default "__VITE_ASSET__1YMzeU9U__"